import { createFileRoute } from "@tanstack/react-router";

import { AmazonSellingPartnerFormPage } from "~/pages/connection-new/amazon-selling-partner-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/amazon_selling_partner",
)({
  component: AmazonSellingPartnerFormPage,
});
